export const DownloadService = {
	downloadContent: (content: string, fileName: string, mimeType: string) => {
		const BOM = "\uFEFF";
		const csvFile = new Blob([BOM + content], { type: mimeType, });

		const downloadLink = document.createElement("a");
		downloadLink.download = fileName;
		downloadLink.href = window.URL.createObjectURL(csvFile);
		downloadLink.style.display = "none";
		downloadLink.click();
	}
}